import { inject, signal } from '@angular/core';
import { AppStateService, HttpErrorService, StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { Router } from '@angular/router';
import { Station } from '../../../models';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationSelectStation {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  httpErrorService = inject(HttpErrorService);
  appStateService = inject(AppStateService);
  router = inject(Router);

  stations: Station[] = [];
  isLoading = signal(true);
  routes = PublicRoutes;
  selectedGroup = this.stationsService.getSelectedGroup();
  selectedStation = this.stationsService.getSelectedStation();

  init() {
    if (this.selectedGroup) {
      this.findAllStations(this.selectedGroup.Id);
    } else {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS]);
    }
  }

  findAllStations(groupId: number) {
    this.isLoading.set(true);
    this.stationsService.findAllStations(groupId).subscribe({
      next: (stations) => this.onStationsSuccess(stations),
      error: (err) => this.onStationsError(err),
    });
  }

  onStationsSuccess(stations: Station[]) {
    this.isLoading.set(false);
    this.stations = stations;
  }

  onStationsError(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load stations');
  }

  onStationClick(station: Station) {
    this.selectedStation = station;
    this.stationsService.setSelectedStation(station);
  }
}